import { render, staticRenderFns } from "./McHeader.vue?vue&type=template&id=6120ea94&scoped=true&"
import script from "./McHeader.vue?vue&type=script&lang=js&"
export * from "./McHeader.vue?vue&type=script&lang=js&"
import style0 from "./McHeader.vue?vue&type=style&index=0&id=6120ea94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120ea94",
  null
  
)

export default component.exports